import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";

export const useLoadingIndicatorStyles = makeStyles((theme: Theme) =>
	createStyles({
		modal: {
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
		},
		paper: {
			display: "flex",
			flexDirection: "column",
			alignItems: "center",
			backgroundColor: theme.palette.background.paper,
			border: "0px",
			borderRadius: "0px",
			boxShadow: theme.shadows[5],
			padding: theme.spacing(4, 8, 6),
		},
	})
);
